// @flow strict

import * as React from 'react';
import cx from 'classnames';
import { MapMarker } from '../../../Partner/Internal/MapMarker';
import PageContentBlock from '../../../../internal/PageContentBlock';
import { Columns, LinkColumn } from '../../../../internal/Columns';
import Filter, { type PropsType as FilterPropsType } from '../Filter';
import type { PartnerType as PartnerTypeType } from '../../../Partner/Internal/PartnerBar';
import type { PartnerType } from '../types';
// eslint-disable-next-line css-modules/no-unused-class
import styles from '../../styles.scss';

export type PropsType = {|
  partners: Array<PartnerType>,
  ...FilterPropsType,
|};

const Title = ({ partnerType, title }: { partnerType: PartnerTypeType, title: string }) => (
  <span className={cx([styles.circle, styles[`is${partnerType}`]])}>{title}</span>
);

const Location = ({ location }: { location: string }) => (
  <span>
    <MapMarker /> {location}
  </span>
);

export default (props: PropsType) => {
  if (props.partners.length === 0) {
    return null;
  }
  return (
    <PageContentBlock title="Ansarada Advantage Partners" background="Dark">
      <Filter
        action={props.action}
        fieldName={props.fieldName}
        searchTerm={props.searchTerm}
        location={props.location}
        service={props.service}
        industry={props.industry}
        industries={props.industries}
        locations={props.locations}
        services={props.services}
      />
      <Columns columns={3}>
        {props.partners.map((partner, index) => (
          /* eslint-disable react/no-array-index-key */
          <LinkColumn
            key={index}
            meta={<Location location={partner.location} />}
            image={partner.image}
            title={<Title partnerType={partner.partnerType} title={partner.title} />}
            text={partner.intro}
            ctaHref={partner.href}
            ctaText="Find out more"
            variant="Dark"
            switchedTitle
          />
          /* eslint-enable react/no-array-index-key */
        ))}
      </Columns>
    </PageContentBlock>
  );
};
